import { businessErrorFactory, BusinessError } from '../../business-error';

import { GENERATE_REPORT_BUSINESS_ERRORS } from './interfaces';

const GENERATE_REPORT_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and report could not be created. Please try again. If the problem still persists, contact with support.';

const GENERATE_REPORT_LIMIT_REACHED =
  // eslint-disable-next-line max-len
  'Sorry but you reached reports limit and you can not create this report. If you still want to create it then please delete one of the existing or contact with support to increase your limit.';

const GENERATE_REPORT_PENDING_LIMIT_REACHED =
  // eslint-disable-next-line max-len
  'Sorry but you reached pending reports limit and you can not create this report in this moment. Wait until all pending reports will be generated or contact with support to increase your limit.';

export const getGenerateReportBusinessError = (
  businessError: GENERATE_REPORT_BUSINESS_ERRORS
): BusinessError | null => {
  switch (businessError) {
    case GENERATE_REPORT_BUSINESS_ERRORS.REPORTS_LIMIT_REACHED: {
      return businessErrorFactory({ message: GENERATE_REPORT_LIMIT_REACHED, severity: 'warning' });
    }
    case GENERATE_REPORT_BUSINESS_ERRORS.PENDING_REPORTS_LIMIT_REACHED: {
      return businessErrorFactory({ message: GENERATE_REPORT_PENDING_LIMIT_REACHED, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({ message: GENERATE_REPORT_UNEXPECTED_ERROR, severity: 'error' });
    }
  }
};
